// extracted by mini-css-extract-plugin
module.exports = {"root":"Gradient_root__zKEsW"};